import styled from 'styled-components'
import { colors, media } from 'client/styles'

export const FeedbackBase = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  padding-block: 40px;
  padding-inline: 20px;

  ${props => props.withBorderTop && `border-block-start: 1px solid ${colors.grey4};`}
`

export const FeedbackRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FeedbackTitle = styled(FeedbackRow)`
  font-weight: 700;
  font-size: 21px;
  line-height: 100%;
  text-align: center;
  color: ${colors.grey1};

  ${media.tablet} {
    font-size: 28px;
  }
`

export const FeedbackSubTitle = styled(FeedbackRow)`
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: ${colors.grey1};
`

export const FeedbackIcon = styled(FeedbackRow)`
  svg {
    height: 24px;
    width: 24px;
    fill: ${colors.grey1};
    margin-block: 24px;
    margin-inline: 0;

    ${media.tablet} {
      height: 32px;
      width: 32px;
    }
  }
`
